import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { Translator } from '@morningtrain/react-translations'
import { Model, TriggerPipelineOnOperationExecute, WhenModelValue } from '@morningtrain/react-resources'
import ResourceFilter from 'support/filters/ResourceFilter'
import { Pipeline } from '@morningtrain/react-helpers'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import SalaryOverviewTitle from 'widgets/salary/SalaryOverviewTitle'
import AddModelValueToEnv from 'support/helpers/AddModelValueToEnv'
import PersonalShiftsInPeriod from 'pages/app/hr/salary/partials/PersonalShiftsInPeriod'
import PersonalSalaryOverviewSmartview from 'widgets/smartviews/hr/salary/PersonalSalaryOverviewSmartview'
import { StaticFilter } from '@morningtrain/react-filters'
import * as UI from 'ui'

export default function SalaryPersonal (props) {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='hr.salary.personal'>
        <Model resourceName='salary.salary_period' operationName='find'>

          <Pipeline>
            <TriggerPipelineOnOperationExecute />
            <MountSmartviewWithModelOnPipe smartview={<PersonalSalaryOverviewSmartview />} replace />
          </Pipeline>

          <UI.PageHeader title={<SalaryOverviewTitle name='title' />}>
            <ResourceFilter
              name='id'
              className='w-44'
              isSearchable={false}
              resourceName='salary.salary_period'
              optionsKey='display_name'
              label={false}
            >
              <StaticFilter name='since_hired' value />
            </ResourceFilter>
          </UI.PageHeader>

          <WhenModelValue name='id'>

            <AddModelValueToEnv name='period_starts_at' path='salary.current_period.period_starts_at' />
            <AddModelValueToEnv name='period_ends_at' path='salary.current_period.period_ends_at' />

            <PersonalShiftsInPeriod />

            <div className='w-full mb-20' />

          </WhenModelValue>

        </Model>
      </Translator>
    </AdminPageWithSmartview>
  )
}
